import { render, staticRenderFns } from "./ShipmentAction.vue?vue&type=template&id=0ded0aca&"
import script from "./ShipmentAction.vue?vue&type=script&lang=js&"
export * from "./ShipmentAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports